





































import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
import KYCActions from "basis/components/kyc/KYCActions.vue";
import KYCStatusSection from "basis/components/kyc/KYCStatusSection.vue";
import { KYCProfile } from "@foxone/api/src/models/account";
import { State } from "vuex-class";
import utils from "basis/utils";

@Component({
  components: {
    "kyc-actions": KYCActions,
    "kyc-status-section": KYCStatusSection
  }
})
class KYCPage extends Mixins(mixins.page) {
  @State(state => state.basis.account.kycProfile) kycProfile!: KYCProfile;

  needAuth = true;

  get title() {
    return this.$t("kyc.title") as string;
  }

  get meta() {
    const { kyc_status: status } = this.kycProfile;
    const kycStatusMeta = utils.kyc.getKYCStatusMeta(status);
    return {
      kycStatusText:
        kycStatusMeta && kycStatusMeta.text && this.$t(kycStatusMeta.text),
      kycStatusColor: kycStatusMeta && kycStatusMeta.color
    };
  }
}
export default KYCPage;
